export default {
  labels: {
    selectOne: 'Select one option',
    selectAll: 'Select all that apply',
    typeResponse: 'Type your response in the text box below.',
    recordResponse: 'Make a recording to answer the question.',
    enterNumeric: 'Enter a numeric response in the field below.',
    rateResponseScale: 'Rate your response on the scale provided.',
    sliderMinimum: 'Minimum value: {value}',
    sliderMaximum: 'Maximum value: {value}',
    selectOneOptionRow: 'Select one option in each row.',
    selectAllOptionsRow: 'Select all options that apply for each row.',
    dragAndDropResponse: 'Drag and drop the options to rank them in order of preference.',
    rankOrderDesktopInstruction: 'Drag and drop items to rank them, or use the + button to add an item to the list. Use the arrow buttons to reorder or the delete button to remove an item.',
    alert: 'Alert',
    minMaxError: 'Please enter a number between {min} and {max}.',
    cameras: 'Cameras',
    microphones: 'Microphones',
    recording: 'Recording',
    noDevicesFound: 'No devices found',
    camera: 'Camera',
    microphone: 'Microphone',
    stopRecording: 'Stop recording',
    startRecording: 'Start recording',
    disableCamera: 'Disable camera',
    enableCamera: 'Enable camera',
    disableMicrophone: 'Disable microphone',
    enableMicrophone: 'Enable microphone',
    settings: 'Settings',
    recordingProgress: 'Recording progress',
    playbackProgress: 'Playback progress',
    play: 'Play',
    pause: 'Pause',
    stop: 'Stop',
    record: 'Record',
    recordAgain: 'Record again',
    retry: 'Retry',
    done: 'Done',
    minRecordTime: 'Please record an answer for {min} seconds.',
    taggingAlert: 'This question is displayed for testing purposes only and will not be visible to respondents in the live survey.',
    tagsCaptured: 'Tags captured:',
    enlargeImage: 'Enlarge image',
    enlargedImage: 'Enlarged image',
    close: 'Close',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    resetZoom: 'Reset zoom',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} of {total}',
    previousImage: 'Previous Image',
    nextImage: 'Next Image',
    imageLoading: 'Loading image',
    imageLoadFailed: 'Image could not be loaded',
  },
  previewExpired: {
    title: 'Preview Expired',
    description: 'Preview links for past versions are available for 24 hours only. Return to Version Control Panel to preview them again if needed.'
  },
  noSelection: 'No Selection',
  actions: {
    increase: 'Increase',
    decrease: 'Decrease'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Survey Preview Terminated',
      titleCompleted: 'Survey Preview Complete',
      previewModeWarning: 'This page is only visible in Preview Mode and will not be shown to live respondents.',
      reachedEndPoint: 'This survey has reached an end point.',
      reachedEndPointCompleted: 'This preview has reached an end point.',
      returnToModify: 'Return to the previous question to modify your answers and test a different survey path.',
      logic: 'Logic'
    }
  }
}
